import axios from "@/api/axios"

const getPaymentTypes = () => {
    return axios.get('/ref/payment-type/list')
        .then(response => response.data);
}

export default {
    getPaymentTypes
}
